import { apiCall } from "../../../../_utils";
import { apiUrls } from "../../../../_constants";

export const adminDashBoardService = {
  getAllPendingPost,
  getAllDashBoardData,
  addInstructor,
  getInstructor,
  deleteDraft,
  getPost,
  reviewPost,
  setPostFrequency,
  showPostCycle,
  unApprovedPost
};

function getAllPendingPost(params) {
  return apiCall("GET", `${apiUrls.posts.base}`, null, params);
}

function getAllDashBoardData() {
  return apiCall("GET", `${apiUrls.posts.data}`);
}

function addInstructor(request, id) {
  const method = id ? "PUT" : "POST";
  let url = apiUrls.instructors.base;
  !!id && (url = `${url}/${id}`);
  return apiCall(method, url, request);
}

function getInstructor(id) {
  return apiCall("GET", `${apiUrls.instructors.base}/${id}`);
}

function deleteDraft(id) {
  return apiCall("DELETE", `${apiUrls.posts.base}/${id}`);
}

function getPost(id) {
  return apiCall("GET", `${apiUrls.posts.base}/${id}`);
}

function reviewPost(request, id) {
  return apiCall("PUT", `${apiUrls.posts.review}/${id}`, request);
}

function setPostFrequency(request) {
  return apiCall("POST", `${apiUrls.posts.postFrequency}`, request);
}

function showPostCycle() {
  return apiCall("GET", `${apiUrls.posts.showPostCycle}`);
}
function unApprovedPost(request,id) {
  return apiCall("PUT", `${apiUrls.posts.unApprovePost}/${id}`,request);
}